import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

function renderH1WithAccent(h1, accent) {
  if (!accent?.word || !h1) return h1;
  const { word } = accent;
  if (!h1.includes(word)) return h1;
  const parts = h1.split(word);
  return (
    <>
      {parts[0]}
      <span className="text-primary dark:text-primary-container">{word}</span>
      {parts.slice(1).join(word)}
    </>
  );
}

/**
 * @param {{
 *   heroImage: string,
 *   heroImageAlt: string,
 *   heroBadge: string,
 *   h1: string,
 *   heroSubtitle: string,
 *   heroAccent?: { word: string, position?: string } | null,
 *   updated: string,
 * }} props
 */
export function GuideHero({ heroImage, heroImageAlt, heroBadge, h1, heroSubtitle, heroAccent, updated }) {
  return (
    <header className="relative pt-20 sm:pt-24 min-h-[min(520px,72vh)] flex items-end sm:items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt={heroImageAlt}
          fetchPriority="high"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent dark:from-background dark:via-background/60" />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 pb-10 sm:pb-14">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-tertiary text-on-tertiary px-4 py-1.5 rounded-full mb-5 uppercase text-xs font-bold tracking-widest shadow-fanhub-tint">
            <Sparkles className="h-3.5 w-3.5 shrink-0" aria-hidden />
            {heroBadge}
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-on-background dark:text-white leading-[1.05] tracking-tighter mb-5 font-headline">
            {renderH1WithAccent(h1, heroAccent)}
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-on-surface-variant dark:text-slate-300 font-medium max-w-2xl leading-relaxed font-body">
            {heroSubtitle}
          </p>
          <p className="mt-4 text-sm text-on-surface-variant/90 dark:text-slate-400">
            <Link to="/guides" className="font-bold text-primary dark:text-primary-container hover:underline">
              Guides
            </Link>
            <span aria-hidden> · </span>
            Updated {updated}
            <span aria-hidden> · </span>
            <span className="text-on-surface-variant/80">WorldCup Fan Planner</span>
          </p>
        </div>
      </div>
    </header>
  );
}

export default GuideHero;
